"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = [
    0,
    4,
    8,
    16,
    24,
    32,
    40,
    48
];
